export enum Align {
    Center = 'center',
    Left = 'left',
    Right = 'right'
}
